<template>
  <div>
    <h1>notFound</h1>
  </div>
</template>

<script>
export default {
  name: 'notFound',
}
</script>

<style scoped>

</style>
